var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuillLinkOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12841_37344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62109 1.97461H12.6836V5.03711M12.0273 2.63086L8.74609 5.91211M7.43359 2.84961H3.49609C3.148 2.84961 2.81416 2.98789 2.56802 3.23403C2.32187 3.48017 2.18359 3.81401 2.18359 4.16211V11.1621C2.18359 11.5102 2.32187 11.844 2.56802 12.0902C2.81416 12.3363 3.148 12.4746 3.49609 12.4746H10.4961C10.8442 12.4746 11.178 12.3363 11.4242 12.0902C11.6703 11.844 11.8086 11.5102 11.8086 11.1621V7.22461",
    stroke: "#71758F",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12841_37344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(-0.00390625 0.662109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuillLinkOut);
export default __webpack_public_path__ + "static/media/quill_link-out.f519015619d4895604bbac2e757b99ae.svg";
export { ForwardRef as ReactComponent };